const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Modal", "uipress-lite"),
  moduleName: "uip-block-modal",
  description: __("Outputs a modal block with a customisable trigger", "uipress-lite"),
  group: "layout",
  icon: "open_in_new",
};
